import React from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import { AMd } from "./aMd"


const query = graphql`
    query MyQuery {
        pageText {
            page {
                workshops {
                    slug
                }
            }
        }
        allGoogleSheetWorkshopsRow {
            nodes {
                aid
                fields {
                    slug
                }
                title
                author
            }
        }
    }

`

export const WorkshopMd = ({ aid }) => {
    aid = Number.parseInt(aid)
    const data = useStaticQuery(query)
    const slug = data.pageText.page.workshops.slug
    const workshops = data.allGoogleSheetWorkshopsRow.nodes
    const workshop = workshops.find(w => w.aid === aid)

    return <AMd component={Link} inverted to={`${slug}/${workshop.fields.slug}`}>{workshop.title}&nbsp;&nbsp;|&nbsp;&nbsp;{workshop.author}</AMd>
}